// src/components/ResultContentCard.jsx
import React from 'react';

/**
 * ResultContentCard
 * Displays a resource/content card with title, description, image, and links
 * Uses mwc-cards.css for styling
 */
export default function ResultContentCard({ content }) {
  if (!content) return null;

  const cardId = content._id || content.tag || content.title;

  return (
    <article 
      className="mwc-card mwc-result-card" 
      aria-labelledby={`result-${cardId}`}
    >
      <div className="mwc-result-card__body">
        <h3 
          id={`result-${cardId}`} 
          className="mwc-result-card__title"
        >
          {content.title}
        </h3>
        
        {content.description && (
          <p className="mwc-result-card__desc">
            {content.description}
          </p>
        )}
        
        {content.imageUrl && (
          <div className="mwc-result-card__media">
            <img 
              src={content.imageUrl} 
              alt={content.title} 
              className="mwc-result-card__image" 
              loading="lazy"
              onError={(e) => {
                console.warn('[ResultContentCard] Image failed to load:', content.imageUrl);
                e.target.style.display = 'none';
              }}
            />
          </div>
        )}

        {content.links && content.links.length > 0 && (
          <div className="mwc-result-card__links" style={{ marginTop: 16 }}>
            <strong style={{ 
              display: 'block', 
              marginBottom: 8,
              color: 'var(--mwc-text)',
              fontSize: '0.9rem'
            }}>
              Related Resources:
            </strong>
            <ul style={{ 
              listStyle: 'none', 
              padding: 0, 
              margin: 0,
              display: 'flex',
              flexDirection: 'column',
              gap: 8
            }}>
              {content.links.map((link, i) => (
                <li key={i}>
                  <a 
                    href={link} 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={{
                      color: 'var(--mwc-primary)',
                      textDecoration: 'none',
                      fontSize: '0.9rem',
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: 6,
                      transition: 'color 0.2s'
                    }}
                    onMouseEnter={(e) => e.target.style.color = 'var(--mwc-primary-hover)'}
                    onMouseLeave={(e) => e.target.style.color = 'var(--mwc-primary)'}
                  >
                    <span>🔗</span>
                    <span style={{
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap'
                    }}>
                      {link}
                    </span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </article>
  );
}